import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { preferencesClient } from '@/api/clients/preferencesClient';
import { NetworkError, ServerError } from '@/api/errors';
import { type HomeLocation } from '@/api/types/homeLocationTypes';
import { useUserInfo } from '@/features/auth/hooks/useUserInfo';
import { isTokenAuthenticated } from '@/features/auth/isTokenAuthenticated';

export const getHomeLocationQueryKey = 'useHomeLocationQuery';

export function useHomeLocationQuery(): UseQueryResult<HomeLocation | null> {
  const { accessToken } = useUserInfo();
  const isAuthenticated = isTokenAuthenticated(accessToken);

  return useQuery({
    retry: (failureCount, error) => {
      switch (error.constructor) {
        case NetworkError:
        case ServerError:
          return failureCount < 3;
      }

      return false;
    },
    throwOnError: false,
    queryKey: [getHomeLocationQueryKey, accessToken],
    queryFn: async () => {
      const homeLocation = await preferencesClient.getHomeLocation();

      return homeLocation;
    },
    // Need to get home location only when user is authenticated
    enabled: isAuthenticated,
  });
}
